import {
  AppBar,
  Box,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tab,
  Tabs,
} from "@mui/material";
import * as React from "react";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import withRouter from "./withRouter";
import { ArrowDropUp, Padding } from "@mui/icons-material";
import "./Navbar.css";

const styles = (theme) => { };

const user = JSON.parse(sessionStorage.getItem('BAT_USER'));
console.log("user?.userAttribute", user?.userAttribute)

let selectedMenu = null;
let selectedClicked = 0;
class AppBarTop extends React.Component {
  state = {
    value: selectedMenu ? selectedMenu : 0,
    open: false,
    anchorEl: null,
  };
  handleMenuClick = (index) => { };
  handleMenuOpen = (index, event) => {
    const { currentTarget } = event;
    selectedMenu = index;
    this.setState({
      open: true,
      anchorEl: currentTarget,
      value: index,
    });
    if (index == selectedClicked) {
      setTimeout(() => {
        let ele = document.getElementsByClassName(`BottomMenu-tab-${index}`);
        if (ele[0].classList.contains("Mui-selected")) {
          ele[0].classList.remove("Mui-selected");
        }
      }, 10);
    }
  };
  handleMenuClose = (item, index) => {
    const { navigate } = this.props;
    this.setState({
      open: false,
      anchorEl: this.state.anchorEl,
    });

    setTimeout(() => {
      this.changeBottomLine(index);
      selectedClicked = index;
    }, 10);
    navigate(this.getPathnameByLabel(item?.functionality_name));


  };

  handleInputSearch = () => { };
  hasPermission = (permission) => {
    return true
    return this.props?.functionalities?.includes(permission);
  };
  changeBottomLine = (index) => {
    let Prevele = document.getElementsByClassName(`BottomMenu-tab-${selectedClicked}`);
    if (Prevele) {
      Prevele[0].style.color = "#00000099";
      const spanToRemove = Prevele[0].getElementsByClassName('BottomMenu-tab-cla')[0];
      if (spanToRemove) {
        spanToRemove.remove();
      }
    }
    let ele = document.getElementsByClassName(`BottomMenu-tab-${index}`);
    if (ele[0].classList.contains("Mui-selected")) {
      ele[0].classList.remove("Mui-selected");
    }
    ele[0].style.color = "#EF7D00";
    if (ele.length > 0) {
      let newDiv = document.createElement("span");
      newDiv.className = "BottomMenu-tab-cla";
      newDiv.style.height = "3px";
      newDiv.style.backgroundColor = "#EF7D00";
      newDiv.style.position = "absolute";
      newDiv.style.bottom = "0px";
      newDiv.style.width = "100%";
      newDiv.style.marginLeft = "5px";
      newDiv.style.borderRadius = "12px";
      ele[0].appendChild(newDiv);
    }
  };
  changeBottomLines = (index) => {
    // Get elements with the class BottomMenu-tab-${index}
    let ele = document.getElementsByClassName(`BottomMenu-tab-${index}`);

    // Check if any elements were found
    if (ele.length > 0) {
      // Loop through all matched elements
      for (let i = 0; i < ele.length; i++) {
        // Check if the element also has the mui-selected class
        if (ele[i].classList.contains("mui-selected")) {
          // Create a new span element
          let newDiv = document.createElement("span");
          newDiv.className = "BottomMenu-tab-cla";
          newDiv.style.height = "8px";
          newDiv.style.backgroundColor = "#EF7D00";
          newDiv.style.position = "absolute";
          newDiv.style.bottom = "0px";
          newDiv.style.width = "100%";
          newDiv.style.marginLeft = "5px";
          newDiv.style.borderRadius = "12px";

          // Append the new span element to the current element
          ele[i].appendChild(newDiv);

          // Change the text color of the element
          ele[i].style.color = "yellow";
        }
      }
    }
  };
  handlePopperMouseEnter = (index) => {
    this.setState({ open: true });
  };

  handlePopperMouseLeave = () => {
    this.setState({ open: false });
  };

  getMenuItems = () => {
    const userData = sessionStorage.getItem('BAT_USER');
    const user = userData ? JSON.parse(userData) : null;
    
    const menuItems = [
        user?.userAttribute === "Global" 
            ? { pathName: "/cropSeasonList", label: "Season Registration" }
            : { pathName: "/seasonRegistration", label: "Season Registration" },
        { pathName: "/getmoduleregistration", label: "Module Registration" },
        { pathName: "/cropStage", label: "Crop Stage Registration" },
        { pathName: "/getCropStageCalendar", label: "Crop Stage Calendar" },
        { pathName: "/hierarchyConfiguration", label: "Hierarchy Configuration" },
        { pathName: "/QuestionnaireSetup", label: "Questionnaire Setup" },
        { pathName: "/ImportFarmer", label: "Import Farmer" },
        { pathName: "/ImportContract", label: "Import Contract" },
        { pathName: "/ImportHierarchy", label: "Import Hierarchy" },
        { pathName: "/ImportFarmer", label: "Import Farmer" },
        { pathName: "/ImportContract", label: "Import Contract" },
        { pathName: "/manageUnannouncedVisit", label: "Manage Unannounced Visit" },
        { pathName: "/manageUnannouncedVisitorSubGrower", label: "Manage Unannounced Visit - Sub Grower" },
        { pathName: "/manageUnannouncedVisitorSubGrower", label: "Manage Unannounced Visitor - Sub Grower" },
        { pathName: "/analyticalreports", label: "Analytical Question Report" },
        { pathName: "/ImportHierarchy", label: "Import Hierarchy" },
        { pathName: "/manageProfiles", label: "Manage Profiles" },
        { pathName: "/users", label: "Manage Users" },
        { pathName: "/reports", label: "Reports" },
        { pathName: "/surveyManagement", label: "Survey Reopen/Approve" },
        { pathName: "/surveyManagementSubGrower", label: "Survey Reopen/Approve - Sub Grower" },
        { pathName: "/userLoginReport", label: "User Login Report" },
        { pathName: "/checkPendingTranslation", label: "Translation report" },
        { pathName: "/promptActionNotification", label: "Prompt Action Notification" },
        { pathName: "/ImportWood", label: "Import Wood Supplier" },
         { pathName: "/woodSupplierTask", label: "Wood Supplier Task" },
         { pathName: "/agri360UserReport", label: "Agri360 User Report" },
         { pathName: "/ImportFT", label: "Import FT to FA Mapping" },
         { pathName: "/ImportSubGrower", label: "Import Sub Grower" },
    ];

    // Add Send Notification menu item only for non-global users
    if (user?.userAttribute !== "Local") {
        menuItems.splice(-2, 0, { 
            pathName: "/sendTranslationNotification", 
            label: "Send Notification for Translation" 
        });
    }

    return menuItems;
  }

  getPathnameByLabel = (label) => {
    const item = this.getMenuItems().find(item => item.label === label);
    return item ? item.pathName : '/';
  }

  render() {
    const { anchorEl, open } = this.state;
    const userData = sessionStorage.getItem('BAT_USER');
    const user = userData ? JSON.parse(userData) : null;

    // Filter accessible modules to exclude translation notification for Global users
    const filteredModules = this.props?.accessibleModules?.map(module => {
      if (user?.userAttribute !== "Global") {
        // Filter out the translation notification functionality
        const filteredFunctionalities = module.accessible_functionalities?.filter(
          func => func.functionality_name !== "Send Notification for Translation"
        );
        return {
          ...module,
          accessible_functionalities: filteredFunctionalities
        };
      }
      return module;
    });

    return (
      <Box className="bottoMenu">
        <AppBar position="static">
          <Paper>
            <Tabs
              className="BottomMenu-list"
              value={this.state.value}
              variant="fullWidth"
              sx={{
                "& .MuiTabs-root": {
                  minHeight: "46px !important",
                },
                "& .MuiTabs-scroller": {
                  display: "none !important",
                },
                "& .MuiTabs-indicator": {
                  display: "none !important",
                },
                "& .MuiTabs-flexContainer": {
                  height: "46px",
                  margin: "0px",
                },
                "& .Mui-selected": {
                  color: "#00000099 !important",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "white !important",
                },
                "& .MuiButtonBase-root": {
                  display: "flex",
                  justifyContent: "center",
                  minHeight: "unset",
                  textTransform: "capitalize",
                },
                "& .MuiTabs-scroller": {
                  padding: "0px",
                },
                paddingTop: "10px",
                textTransform: "capitalize",
              }}
            >
              {filteredModules?.map((item, index) => (
                <Tab
                  className={`BottomMenu-tab-${index}`}
                  key={index}
                  onMouseEnter={this.handleMenuOpen.bind(this, index)}
                  data-key={index}
                  sx={{
                    justifyContent: "space-around",
                    cursor: "default",
                    textTransform: "capitalize",
                  }}
                  label={item?.module_name}
                  aria-owns={open ? "menu-list-grow" : undefined}
                  aria-haspopup={"true"}
                  component="div"
                  icon={
                    open && this.state.value === index ? (
                      <ArrowDropDown />
                    ) : (
                      <ArrowDropUp />
                    )
                  }
                  iconPosition="right"
                />
              ))}
            </Tabs>
            <Popper
              onMouseEnter={this.handlePopperMouseEnter}
              onMouseLeave={this.handlePopperMouseLeave}
              open={this.state.open}
              anchorEl={anchorEl}
              id="menu-list-grow"
              sx={{
                width: anchorEl ? anchorEl.clientWidth : "auto",
                zIndex: 999,
                maxWidth: '300px' // Add maximum width
              }}
            >
              <Paper 
                sx={{ 
                  minWidth: "200px",
                  maxWidth: '100%' // Make paper take full width of popper
                }}
              >
                <MenuList>
                  {filteredModules?.map((ele, index1) => {
                    return ele?.accessible_functionalities?.map((ele2, index2) => {
                      return <div>
                        {this.state.value === index1 &&
                          <MenuItem
                            key={index2}
                            onClick={() => this.handleMenuClose(ele2, index1)}
                            sx={{
                              whiteSpace: 'normal',
                              wordBreak: 'break-word',
                              lineHeight: 1.2,
                              padding: '8px 16px',
                              minHeight: 'unset',
                              '& .MuiMenuItem-root': {
                                whiteSpace: 'normal'
                              }
                            }}
                          >
                            {ele2?.functionality_name}
                          </MenuItem>
                        }

                      </div>

                    })
                  })}
                </MenuList>
              </Paper>
            </Popper>
          </Paper>
        </AppBar>
      </Box>
    );
  }
}
export default withRouter(AppBarTop);
